
import {FC, useMemo} from "react";
import {CreatePlanSummary} from "../../view-model";
import {usePlan} from "../../context";
import {summarizePlan} from "../../helpers";
import {validateAndExtractTenantIdForHierarchy} from "../../transforms";
import {CreatePlanTreeView, SummaryCard} from "../common";
import {ReviewPlanStepNodeLabel} from "./ReviewPlanStepNodeLabel";
import "../common/BuilderStep.scss";

export const ReviewPlanStep: FC = () => {
  const {plan, hierarchy} = usePlan();

  const resolution = useMemo(() => {
    try {
      return validateAndExtractTenantIdForHierarchy(hierarchy);
    } catch {
      return {tenantId: undefined};
    }
  }, [hierarchy]);

  const summary = useMemo<CreatePlanSummary>(
    () => summarizePlan(plan, resolution.tenantId ?? ""),
    [plan, resolution.tenantId]
  );

  return (
    <section
      data-testid={"review-plan-step"}
      className={"hierarchy-builder-step review-plan-step"}>
      <section data-testid={"summary-section"} className={"summary-section"}>
        <SummaryCard
          baseKey={"create-operational-hierarchy.plan-summary.creating"}
          count={summary.creating.length}
        />
        <SummaryCard
          baseKey={"create-operational-hierarchy.plan-summary.existing"}
          count={summary.existing.length}
        />
        <SummaryCard
          baseKey={"create-operational-hierarchy.plan-summary"}
          qualifier={summary.tenantId ? "existing-tenant" : "new-tenant"}
          count={1}
          name={summary.tenantName}
        />
      </section>
      <section
        data-testid={"hierarchy-section"}
        className={"hierarchy-section"}>
        <CreatePlanTreeView
          interactive={false}
          label={ReviewPlanStepNodeLabel}
        />
      </section>
    </section>
  );
};
